import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@nerdwallet/react-typography';
import Icon from '@nerdwallet/react-icon';
import analyticsLib from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';

var ProductDetailsToggle = function ProductDetailsToggle(_ref) {
  var analytics = _ref.analytics,
      isExpanded = _ref.isExpanded,
      onClick = _ref.onClick,
      customToggleText = _ref.customToggleText;

  function getClassName() {
    if (isExpanded) {
      return 'hide-details';
    }

    return 'show-details';
  }

  function getSpanText() {
    if (isExpanded) {
      return customToggleText.hide || 'Hide Details';
    }

    return customToggleText.show || 'Show Details';
  }

  function getIcon() {
    if (isExpanded) {
      return 'navigateup';
    }

    return 'navigatedown';
  }

  function internalOnClick(impressionId) {
    if (!_isEmpty(analytics)) {
      var entityName = isExpanded ? _get(analytics, 'hideEntityName') : _get(analytics, 'seeEntityName');
      analyticsLib.track('element_interacted', {
        action: isExpanded ? 'collapse' : 'expand',
        entity_name: entityName || 'toggle_details',
        interaction_type: 'press',
        impression_id: impressionId
      });
    }

    onClick();
  }

  return React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
    return React.createElement("span", {
      className: getClassName(),
      onClick: function onClick() {
        return internalOnClick(_get(impressionContext, 'impressionId'));
      }
    }, React.createElement(Icon, {
      font: "gizmo",
      icon: getIcon()
    }), React.createElement("span", {
      className: "toggle-label"
    }, React.createElement(Text, {
      small: true
    }, getSpanText())));
  });
};

ProductDetailsToggle.displayName = 'ProductDetailsToggle';
ProductDetailsToggle.defaultProps = {
  customToggleText: {}
};
ProductDetailsToggle.propTypes = {
  analytics: PropTypes.shape({
    detailsDrawer: PropTypes.shape({
      entityName: PropTypes.string
    })
  }),
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  customToggleText: PropTypes.shape({
    show: PropTypes.string,
    hide: PropTypes.string
  })
};
export default ProductDetailsToggle;